import MyFatorah from "../../../assets/images/myfatora.png";
import MyFatorahCards from "../../../assets/images/myfatoorah-cards.png";
import Tabby from "../../../assets/images/tabby.png";
import TabbyCards from "../../../assets/images/tabby-cards.png";
import JeelPay from '../../../assets/images/jeelpay.png';
import JeelPayCards from '../../../assets/images/jeel-cards.png';
import Check from '../../../assets/icons/Check.svg';
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useUserSelection } from "../../../store/UserPayment";
import getToken from "../../../hooks/getToken";
import Toast from "../../ui/Toast";
import { useTranslation } from "react-i18next";

const PaymentWay = ({ page }) => {
    const { t } = useTranslation();
    document.title = page === 'offers' ? `${t('routes.offers')} | ${t('routes.payment-way')}` : `${t('routes.training-courses')} | ${t('routes.payment-way')}`;
    const navigate = useNavigate();
    const { id } = useParams();
    const { setSelectedPayment, selectedPayment, rowDetails } = useUserSelection();
    
    const ways = [
        {
            title: t('training-courses.bank-transfer.title'),
            subjects: t('training-courses.bank-transfer.subjects', {returnObjects : true}),
            value: 'bank-transfer'
        },
        {
            title: t('training-courses.fatoorah.title'),
            subjects: t('training-courses.fatoorah.subjects', { returnObjects: true }),
            wayImg: MyFatorah,
            waySubjectImgs: MyFatorahCards,
            value: 'fatoorah'
        },
        {
            title: t('training-courses.tabby.title'),
            subjects: t('training-courses.tabby.subjects', { returnObjects: true }),
            wayImg: Tabby,
            waySubjectImgs: TabbyCards,
            value: 'tabby'
        },
        {
            title: t('training-courses.jeel.title'),
            subjects: t('training-courses.jeel.subjects', { returnObjects: true }),
            wayImg: JeelPay,
            waySubjectImgs: JeelPayCards,
            value: 'jeel'
        },
    ];
    const [isSelected, setIsSelected] = useState(false);

    useEffect(() => {
        const seeToken = getToken();
        if (!seeToken) {
            const timeout = setTimeout(() => {
                navigate('/login');
            }, 5000);

            return () => clearTimeout(timeout);
        }
    }, []);


    useEffect(() => {
        const toPreventRefresh = (e) => {
            const confirmRefresh = window.confirm(
                t('custom.sure')
            );
            if (confirmRefresh) {
                navigate(`/${page}/${id}`);
            } else {
                e.preventDefault();
            }
        };
        if (rowDetails.courseId === '') {
            navigate(`/${page}/${id}`);
        }
        window.addEventListener('beforeunload', toPreventRefresh);
        return () => {
            window.removeEventListener('beforeunload', toPreventRefresh);
        };
    }, [rowDetails.courseId]);

    return (
        <>
            <main className="border rounded-xl p-4 pb-0 z-50">
                <section className="grid grid-cols-2 gap-2 max-lg:grid-cols-1">
                    {
                        ways.map((way, i) => (
                            <div key={i} className="p-3 border rounded-md cursor-pointer hover:bg-gray-100 transition-all delay-100 ease-in-out hover:ring-1 hover:ring-slate-100"
                                onClick={() => setSelectedPayment((prev) => ({
                                    ...prev,
                                    payment: way.value,
                                    paymentInAr: way.title
                                }))}
                            >
                                <div className="flex justify-between items-center gap-2">
                                    <div className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            name="payment-way"
                                            id={way.value}
                                            value={way.value}
                                            onChange={(e) => setSelectedPayment((prev) => ({
                                                ...prev,
                                                payment: e.target.value,
                                                paymentInAr: way.title
                                            }))}
                                            checked={way.value === selectedPayment.payment}
                                        />
                                        <span>
                                            {way.title}
                                        </span>
                                    </div>
                                    <div>
                                        {way.wayImg && <img src={way.wayImg} alt={way.title} className="w-24" />}
                                    </div>
                                </div>
                                <ul className="my-2">
                                    {way.subjects.map((subject, i) => (
                                        <li key={i} className="grid grid-cols-[6%_93%] text-start">
                                            <span className="mt-2">
                                                <img src={Check} alt="check-icon" />
                                            </span>
                                            <span className="text-sm text-start">
                                                {subject}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                                {way.waySubjectImgs &&
                                    <div className="mt-4">
                                        <img src={way.waySubjectImgs} alt={way.title} className={`${way.title === t('training-courses.tabby.title') ? 'w-24' : 'w-36'}`} />
                                    </div>}
                            </div>
                        ))
                    }
                </section>
                <div className="flex items-center justify-end my-3">
                    <button
                        className={`bg-primary-tw text-white py-1 px-5 ${selectedPayment.payment === '' ? 'cursor-not-allowed opacity-65' : 'cursor-pointer opacity-100'} rounded-lg`}
                        onClick={() => {
                            if (selectedPayment.payment === '') {
                                setIsSelected(true);
                                setTimeout(() => setIsSelected(false), 4000)
                            } else {
                                navigate('../card')
                            }
                        }}
                    >
                        {t('custom.ok')}
                    </button>
                </div>
            </main>
            <Toast state={isSelected}>
                <p className="text-white text-center text-lg">
                    {t('training-courses.choose-way')}
                </p>
            </Toast>
        </>
    );
}
export default PaymentWay;